import React, {useEffect, useState} from 'react'
import { Card, CardBody, CardHeader, Flex, Heading, Table, TableCaption, 
        TableContainer, Tbody, Th, Thead, Tr, Td, Button, Box, VStack, Text, 
        HStack, useBreakpointValue} from '@chakra-ui/react'
import {CompanyModal} from './CompanyModal/CompanyModal'
import {CompanyCatalogModal} from './CompanyCatalogModal/CompanyCatalogModal'
import {CompanyDeleteButton} from './CompanyDeleteButton/CompanyDeleteButton'
import {NavLink} from 'react-router-dom'
import { api } from 'apis/configs/axiosConfigs'

const Companies = () => {

    const [companies, setCompanies] = useState([])
    const isMobile = useBreakpointValue({ base: true, lg: false })

    const fetchCompanies = async (cancel = false) => {
        return api.request({
            url: '/company/index',
            method: 'GET',
            signal: cancel ? api.cancelApiObject.fetchCompanies.handleRequestCancellation().signal : undefined,
        }).then(response => {
            setCompanies(response.data.result)
            return response.data.result
        }).catch(error => {
            console.error('Error fetching companies:', error)
            throw error
        })
    } 

    // const {companies, fetchCompanies} = useApi()

    useEffect(() => {
        fetchCompanies()
    }, [])
    // useEffect(() => {
    //     console.log('companies', companies)
    // }, [companies])

    return (
    <>
        <Card m={2}>
            <CardHeader>
                <Flex justifyContent='space-between' alignItems='center'>
                    <Heading m={3} size='md'> Companies </Heading>
                    <CompanyModal fetchCompanies={fetchCompanies} mode={'new'}/>
                </Flex>
            </CardHeader>
            <CardBody>
                {isMobile ? (
                    <VStack spacing={4} align='stretch' mt={4}>
                    {companies.map(({_id, name, file, catalog_last_modified }) => (
                            <Box key={_id} borderWidth='1px' borderRadius='12px' p={4}>
                                <Text fontWeight='600' fontSize='md' mb={2}>{name}</Text>
                                <VStack align='stretch' spacing={1} borderTopWidth='1px' pt={2} fontSize='sm'>
                                    <HStack justify='space-between'>
                                        <Text color='gray.500'>Status</Text>
                                        <Text>Enabled</Text>
                                    </HStack>
                                    <HStack justify='space-between'>
                                        <Text color='gray.500'>Catalog Updated</Text>
                                        <Text textAlign='right'>{catalog_last_modified}</Text>
                                    </HStack>
                                </VStack>
                                    <HStack mt={3} justify='flex-end' spacing={2}>
                                        <Button mr={2} as={NavLink} to={`/stores/${_id}`} colorScheme='teal' size='sm'>Shops</Button>
                                        <CompanyModal fetchCompanies={fetchCompanies} id={_id} name={name} file={file} mode='edit'/>
                                        <CompanyCatalogModal id={_id} name={name} file={file}/>
                                        <CompanyDeleteButton id={_id} fetchCompanies={fetchCompanies}/>
                                    </HStack>
                            </Box>
                            ))}
                    </VStack>
                        ) : (
                <TableContainer>
                    <Table variant='striped'>
                        <TableCaption>List of the companies</TableCaption>
                        <Thead>
                            <Tr>
                                <Th>Name</Th>
                                <Th>Actions</Th>
                                <Th>Status</Th>
                                <Th>Catalog Updated</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {companies.map(({_id, name, file, catalog_last_modified }) => (
                                <Tr key={_id}>
                                    <Td> {name} </Td>
                                    <Td>
                                        <Button mr={2} as={NavLink} to={`/stores/${_id}`} colorScheme='teal' size='sm'>Shops</Button>
                                        <CompanyModal fetchCompanies={fetchCompanies} id={_id} name={name} file={file} mode='edit'/>
                                        <CompanyCatalogModal id={_id} name={name} file={file}/>
                                        <CompanyDeleteButton id={_id} fetchCompanies={fetchCompanies}/>
                                    </Td>
                                    <Td> Enabled </Td>
                                    <Td> {catalog_last_modified} </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
                        )}
            </CardBody>
        </Card>
    </>
    )
}

export default Companies